import { DomainError } from "./errors";

/** Cursor maior que isso é rejeitado antes de decodificar. */
export const MAX_CURSOR_LENGTH = 1024;

const encoder = new TextEncoder();
// `ignoreBOM: false` é o padrão; explícito porque os tipos do workerd exigem o campo.
const decoder = new TextDecoder("utf-8", { fatal: true, ignoreBOM: false });

const invalid = () => new DomainError("invalid_cursor", "Cursor inválido");

/** Serializa qualquer valor JSON como base64url sobre UTF-8 (seguro para nomes com acento, ’, emoji). */
export function encodeCursor(value: unknown): string {
  const bytes = encoder.encode(JSON.stringify(value));
  let bin = "";
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/**
 * Decodifica um cursor de `encodeCursor`. Qualquer falha (base64, UTF-8, JSON ou `guard`)
 * lança `DomainError("invalid_cursor")`, que a API mapeia para 400.
 */
export function decodeCursor(cursor: string): unknown;
export function decodeCursor<T>(cursor: string, guard: (v: unknown) => v is T): T;
export function decodeCursor<T>(cursor: string, guard?: (v: unknown) => v is T): unknown {
  if (cursor.length === 0 || cursor.length > MAX_CURSOR_LENGTH || !/^[A-Za-z0-9_-]+$/.test(cursor)) {
    throw invalid();
  }
  let value: unknown;
  try {
    const b64 = cursor.replace(/-/g, "+").replace(/_/g, "/");
    const bin = atob(b64 + "=".repeat((4 - (b64.length % 4)) % 4));
    value = JSON.parse(decoder.decode(Uint8Array.from(bin, (ch) => ch.charCodeAt(0))));
  } catch {
    throw invalid();
  }
  if (guard && !guard(value)) throw invalid();
  return value;
}
